module.exports = __webpack_public_path__ + "static/media/image-1.55d50cf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-1.jpg
// module id = 254
// module chunks = 0